import React, { useState, useEffect } from "react";
import { Card, Grid, Sticky, Button, Icon, Dimmer, Loader } from "semantic-ui-react";
import { Navigate, useNavigate } from "react-router-dom";
import "../css/Events.css";
import "../css/RSO.css";
import "../css/MyRSOs.css";

export default function ApproveEvents() {
    const [approvePublicEventList, setApprovePublicEventList] = useState([]);
    const [approvePrivateEventList, setApprovePrivateEventList] = useState([]);
    const [approveRSOEventList, setApproveRSOEventList] = useState([]);
    const [updateCheck, setUpdateCheck] = useState(0);
    let navigate = useNavigate();

    useEffect(() => {
        console.log(localStorage.getItem("uniid"));
        handleGetApprovePublicEvent()
        handleGetApprovePrivateEvent()
        handleGetApproveRSOEvent()
    }, []);

    useEffect(() => {
        handleGetApprovePublicEvent()
        handleGetApprovePrivateEvent()
        handleGetApproveRSOEvent()
    }, [updateCheck]);

    const redirectLogin = () => {
        localStorage.clear();
        navigate("/");
    };

    const redirectUniversity = () => {
        navigate("/MyUniversity");
    };

    const redirectRSO = () => {
        navigate("/RSO");
    };

    const redirectApproveRSO = () => {
        navigate("/ApproveRSOs");
    };

    const redirectApproveEvent = () => {
        navigate("/ApproveEvents");
    };

    //FIX NAVIGATION LINK
    const redirectEvent = () => {
        navigate("/Events");
    };

    async function handleGetApprovePublicEvent() {
        try {
            let info = {
                userid: localStorage.getItem("userid")
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/listPublicEventsToApprove.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "application/json" },
                }
            );

            let res = await response.json();
            console.log("This is the response error: " + res.error);

            if (res.error === "") {
                setApprovePublicEventList(res.results);
            }
        } catch (error) {
            console.log(error);
        }
    }

    async function handleGetApprovePrivateEvent() {
        try {
            let info = {
                userid: localStorage.getItem("userid")
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/listPrivateEventsToApprove.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "application/json" },
                }
            );

            let res = await response.json();
            console.log("This is the response error: " + res.error);

            if (res.error === "") {
                setApprovePrivateEventList(res.results);
            }
        } catch (error) {
            console.log(error);
        }
    }

    async function handleGetApproveRSOEvent() {
        try {
            let info = {
                userid: localStorage.getItem("userid")
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/listRSOEventsToApprove.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "application/json" },
                }
            );

            let res = await response.json();
            console.log("This is the response error: " + res.error);

            if (res.error === "") {
                setApproveRSOEventList(res.results);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleApprovePublic = (event) => (e) => {
        handleApprovePublicHelper(event);
    };

    async function handleApprovePublicHelper(event) {
        try {
            let info = {
                eventid: event.eventid
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/approvePublicEvents.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "applicaton/json" },
                }
            );

            let res = await response.json();

            console.log("Error message: " + res.error);

            if (res.error === "") {
                setUpdateCheck(updateCheck + 1);
            } else {
                alert(res.error);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleApprovePrivate = (event) => (e) => {
        handleApprovePrivateHelper(event);
    };

    async function handleApprovePrivateHelper(event) {
        try {
            let info = {
                eventid: event.eventid
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/approvePrivateEvents.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "applicaton/json" },
                }
            );

            let res = await response.json();

            console.log("Error message: " + res.error);

            if (res.error === "") {
                setUpdateCheck(updateCheck + 1);
            } else {
                alert(res.error);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleApproveRSOEvent = (event) => (e) => {
        handleApproveRSOEventHelper(event);
    };

    async function handleApproveRSOEventHelper(event) {
        try {
            let info = {
                eventid: event.eventid
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/approveRsoEvents.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "applicaton/json" },
                }
            );

            let res = await response.json();

            console.log("Error message: " + res.error);

            if (res.error === "") {
                setUpdateCheck(updateCheck + 1);
            } else {
                alert(res.error);
            }
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <div className="ui center aligned padded grid">
            <div className="row events-row">
                <div className="events-blue-sidebar column three wide">
                    <h2 className="events-hi-user">Hi, {localStorage.getItem("first")}</h2>
                    <p className="events-subpage-link" onClick={redirectUniversity}>My University</p>
                    <p className="events-subpage-link" onClick={redirectApproveRSO}>Approve RSOs</p>
                    <p className="events-subpage-link" onClick={redirectApproveEvent}>Approve Events</p>
                    <h2 className="events-sidebar-subtitle">EXPLORE</h2>
                    <p className="events-subpage-link" onClick={redirectRSO}>RSOs</p>
                    <p className="events-subpage-link" onClick={redirectEvent}>Events</p>
                    <Button icon onClick={redirectLogin}>
                        <Icon className="event-icon2" name='sign-out' size='large' />
                    </Button>
                </div>
                <div className="events-right-container column thirteen wide">
                    <h2 className="MyRSO-titletwo">
                        Public Events to Approve:
                    </h2>
                    <div className="events-event-cards-container">
                        {(approvePublicEventList.length !== 0) ?
                        (approvePublicEventList.map((event) => (
                            <div className="RSO-card-container">
                                {!approvePublicEventList.some(
                                (approvedEvent) =>
                                    approvedEvent.results ===
                                    "No Records") ? (
                                <Card fluid>
                                    <Grid
                                        container
                                        columns={6}
                                        className="RSO-grid-card"
                                    >
                                        <Grid.Column>
                                            <h2 className="RSO-name">
                                                {event.event_name}
                                            </h2>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <p className="RSO-description">
                                                {event.description}
                                            </p>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <p className="MyRSO-status">
                                                <b><u>Location:</u></b>
                                            </p>
                                            <p className="MyRSO-description">
                                                {event.lname}
                                            </p>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <p className="MyRSO-status">
                                                <b><u>Date:</u></b>
                                            </p>
                                            <p className="MyRSO-description">
                                                {event.date}
                                            </p>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <p className="MyRSO-status">
                                                <b><u>Duration:</u></b>
                                            </p>
                                            <p className="MyRSO-description">
                                                {event.startTime} - {event.endTime}
                                            </p>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Button
                                                color="blue"
                                                size="massive"
                                                className="RSO-button"
                                                onClick={handleApprovePublic(event)}
                                            >
                                                APPROVE
                                            </Button>
                                        </Grid.Column>
                                    </Grid>
                                </Card>
                                ):(<h3>No Public Events Needing Approval</h3>)}
                            </div>
                        ))) :
                        (<Dimmer active inverted>
                            <Loader inverted content='Loading' />
                        </Dimmer>)}
                    </div>
                    <h2 className="MyRSO-titletwo">
                        Private Events to Approve:
                    </h2>
                    <div className="events-event-cards-container">
                        {(approvePrivateEventList.length !== 0) ?
                        (approvePrivateEventList.map((event) => (
                            <div className="RSO-card-container">
                                {!approvePrivateEventList.some(
                                (approvedEvent) =>
                                    approvedEvent.results ===
                                    "No Records") ? (
                                <Card fluid>
                                    <Grid
                                        container
                                        columns={6}
                                        className="RSO-grid-card"
                                    >
                                        <Grid.Column>
                                            <h2 className="RSO-name">
                                                {event.event_name}
                                            </h2>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <p className="RSO-description">
                                                {event.description}
                                            </p>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <p className="MyRSO-status">
                                                <b><u>Location:</u></b>
                                            </p>
                                            <p className="MyRSO-description">
                                                {event.lname}
                                            </p>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <p className="MyRSO-status">
                                                <b><u>Date:</u></b>
                                            </p>
                                            <p className="MyRSO-description">
                                                {event.date}
                                            </p>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <p className="MyRSO-status">
                                                <b><u>Duration:</u></b>
                                            </p>
                                            <p className="MyRSO-description">
                                                {event.startTime} - {event.endTime}
                                            </p>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Button
                                                color="blue"
                                                size="massive"
                                                className="RSO-button"
                                                onClick={handleApprovePrivate(event)}
                                            >
                                                APPROVE
                                            </Button>
                                        </Grid.Column>
                                    </Grid>
                                </Card>
                                ):(<h3>No Private Events Needing Approval</h3>)}
                            </div>
                        ))) :
                        (<Dimmer active inverted>
                            <Loader inverted content='Loading' />
                        </Dimmer>)}
                    </div>
                    <h2 className="MyRSO-titletwo">
                        RSO Events to Approve:
                    </h2>
                    <div className="events-event-cards-container">
                        {(approveRSOEventList.length !== 0) ?
                        (approveRSOEventList.map((event) => (
                            <div className="RSO-card-container">
                                {!approveRSOEventList.some(
                                (approvedEvent) =>
                                    approvedEvent.results ===
                                    "No Records") ? (
                                <Card fluid>
                                    <Grid
                                        container
                                        columns={6}
                                        className="RSO-grid-card"
                                    >
                                        <Grid.Column>
                                            <h2 className="RSO-name">
                                                {event.event_name}
                                            </h2>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <p className="RSO-description">
                                                {event.description}
                                            </p>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <p className="MyRSO-status">
                                                <b><u>Location:</u></b>
                                            </p>
                                            <p className="MyRSO-description">
                                                {event.lname}
                                            </p>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <p className="MyRSO-status">
                                                <b><u>Date:</u></b>
                                            </p>
                                            <p className="MyRSO-description">
                                                {event.date}
                                            </p>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <p className="MyRSO-status">
                                                <b><u>Duration:</u></b>
                                            </p>
                                            <p className="MyRSO-description">
                                                {event.startTime} - {event.endTime}
                                            </p>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Button
                                                color="blue"
                                                size="massive"
                                                className="RSO-button"
                                                onClick={handleApproveRSOEvent(event)}
                                            >
                                                APPROVE
                                            </Button>
                                        </Grid.Column>
                                    </Grid>
                                </Card>
                                ):(<h3>No RSO Events Needing Approval</h3>)}
                            </div>
                        ))) :
                        (<Dimmer active inverted>
                            <Loader inverted content='Loading' />
                        </Dimmer>)}
                    </div>
                </div>
            </div>
        </div>
    );
}